import { Controller, FieldValues } from 'react-hook-form';
import { DatePicker } from '@shape-ds/components';
import { dayjs } from 'lib/dayjs';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { FormInputProps } from './FormInputProps';

export const validateDate = (value: string, minDate?: string) => {
  if (!minDate || !value) return true;
  if (minDate && (dayjs(value).isAfter(dayjs(minDate)) || dayjs(value).isSame(dayjs(minDate)))) {
    return true;
  }
  return t('components:inputs.invalid_date');
};

export const FormDatePicker = <T extends FieldValues>({
  name,
  control,
  label,
  dateFormat,
  isRequired,
  minDate,
  disabled,
  ...props
}: FormInputProps<T>) => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? t('components:inputs.required_field') : false,
        validate: {
          validateDate: (value) => validateDate(value, minDate),
        },
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div data-testid={name} className={name.replace(/\./g, '-')}>
            <DatePicker
              {...props}
              required={isRequired}
              label={label}
              data-testid={name}
              helperText={error?.message}
              format={dateFormat}
              error={!!error}
              onChange={(date) => {
                date?.toString() ? onChange(date.toString()) : onChange(undefined);
              }}
              value={value ? dayjs(value) : null}
              fullWidth
              minDate={minDate ? dayjs(minDate) : undefined}
              className="cd-date"
              disabled={disabled}
              slots={{ openPickerIcon: CalendarMonthIcon }}
            />
          </div>
        );
      }}
    />
  );
};
